import React from "react";
import styled from "styled-components";
import TextArea from "../textArea/TextArea";
import Colors from "../../constants/Colors";
import {deviceMax} from "../../../styles/device";
import ReadTheStoriesButton from "../heroAreaButtons/ReadTheStoriesButton";
import SendStoryButton from "../heroAreaButtons/SendStory";
import {NavigationURLs} from "../../functions/NavigationFunctions";

const SuccessStoriesHeroAreaContent = () => {
    return (
        <SuccessStoriesHeroAreaContentWrapper>
            <TextArea>
                <h1>Başarı hikayelerimiz</h1>
                <h2>
                    Yayına girdiğimiz günden bu yana yüzlerce başarı hikayemiz oldu.
                    <br/>
                    <br/>
                    Ya sizin hikayeniz?
                </h2>
            </TextArea>
            <ReadTheStoriesButton backgroundColor={'#fff'} textColor={false}/>
            <SendStoryButton backgroundColor={'#D2147D'} textColor={true} url={NavigationURLs.successStorySend}/>
        </SuccessStoriesHeroAreaContentWrapper>
    )
}

const SuccessStoriesHeroAreaContentWrapper = styled.div`
  flex: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 24px;

  @media ${deviceMax.laptop} {
    padding-top: 10px;
    padding-bottom: 3px;
    padding-left: 0;
  }

  > div {
    display: flex;
    flex-direction: column;
    background-color: unset;
    padding: 0 40px 20px 0;
    width: 100%;
    max-width: 474px;

    @media ${deviceMax.laptop} {
      align-items: center;
      padding-bottom: 0;
      padding-right: 0;
    }

    > h1 {
      font-weight: 800;
      font-size: 32px;
      line-height: 40px;
      letter-spacing: 0;
      text-transform: uppercase;
      color: ${Colors.white};
      margin-top: 0;
      margin-bottom: 17px;

      @media ${deviceMax.laptop} {
        text-align: center;
        font-size: 18px;
        line-height: 28px;
      }
    }

    > h2 {
      font-weight: 700;
      font-size: 30px;
      line-height: 45px;
      letter-spacing: 0;
      color: ${Colors.white};
      margin-bottom: 32px;

      @media ${deviceMax.laptop} {
        text-align: center;
        font-size: 16px;
        line-height: 24px;
        margin-top: 6px;
        margin-bottom: 30px;
        padding-left: 20px;
        padding-right: 20px;
      }
    }

    > p {
      font-weight: 800;
      font-size: 18px;
      line-height: 30px;
      letter-spacing: 0;
      color: ${Colors.white};
      margin-top: 0;

      @media ${deviceMax.laptop} {
        font-size: 16px;
        line-height: 24px;
        text-align: center;
      }
    }

    > ul {
      list-style: none;
      padding: 0;
      margin: 0 0 28px 0;

      > li {
        margin-bottom: 10px;
        font-weight: 800;
        font-size: 20px;
        line-height: 22px;
        letter-spacing: 0;
        color: ${Colors.white};
        padding-left: 35px;

        > div {
          &:before, &:after {
            background: ${Colors.white};
          }
        }

        @media ${deviceMax.laptop} {
          font-size: 18px;
          padding-left: 55px;
        }
      }
    }
    
    &:nth-child(2) {
      
      @media ${deviceMax.laptop} {
        display: none;
      }
      > a {
        > div {
          > div {
            color: ${Colors.purpleColor};
          }
        }
      }
    }
    
    &:nth-child(3) {
      margin-top: -24px;
      margin-bottom: 15px;

      @media ${deviceMax.laptop} {
        display: none;
      }
    }
    
  }
`

export default SuccessStoriesHeroAreaContent;
